import { render, staticRenderFns } from "./PLabel.vue?vue&type=template&id=06c2fc60"
import script from "./PLabel.vue?vue&type=script&lang=js"
export * from "./PLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports